import { IOption } from '@cbridge-utils/options';
import { IAutocompleteValueType } from '../AutocompleteFieldControl.interface';

export const getValueAsOption = (value: IAutocompleteValueType, options: IOption[]): IOption => {
  if (typeof value === 'string' || typeof value === 'number') {
    return options?.find((option) => option.value === value);
  }

  return value;
};
